import React from 'react';
import { motion } from 'framer-motion';
import { FaQuoteLeft, FaStar } from 'react-icons/fa';

const Testimonials = () => {
  const testimonials = [
    {
      quote: "DZF Distribution a transformé notre entrée sur le marché canadien. Leur connaissance approfondie des réglementations et leur réseau de distribution nous ont permis d'économiser des mois de travail.",
      position: "Directrice des Exportations, Entreprise Agroalimentaire",
      rating: 5,
    },
    {
      quote: "Notre partenariat avec DZF a été décisif dans notre développement au Québec. Leur équipe multilingue comprend parfaitement les nuances du marché local.",
      position: "PDG, Réseau de Distribution Alimentaire",
      rating: 5,
    },
    {
      quote: "Travailler avec DZF Distribution nous a permis de nous concentrer sur la qualité de nos produits, pendant qu'ils s'occupaient de toute la logistique et la distribution.",
      position: "Fondateur, Entreprise de Produits Gourmets",
      rating: 4,
    },
  ];

  return (
    <section className="section bg-gray-100">
      <div className="container-custom">
        <div className="text-center mb-12">
          <h2 className="section-title">Témoignages</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ce que nos partenaires disent de notre collaboration
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="bg-white p-8 rounded-lg shadow-md relative"
            >
              <FaQuoteLeft className="text-primary/10 text-6xl absolute top-4 left-4" />
              <div className="relative">
                <div className="flex mb-4">
                  {[...Array(5)].map((_, i) => (
                    <FaStar
                      key={i}
                      className={`${
                        i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'
                      } text-xl`}
                    />
                  ))}
                </div>
                <p className="text-gray-600 italic mb-6">{testimonial.quote}</p>
                <div>
                  <p className="text-gray-500 text-sm">{testimonial.position}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials; 